/* eslint react/no-string-refs: "off" */

import React from 'react';
import _ from 'lodash';

import { WORKER_STATUS } from '../utilities/constants';

export class FieldTreeWorkerManagerBase extends React.Component {
  constructor(props) {
    super(props);

    this.inputTimer;

    this.state = {
      company_id: props.dialog.state.company_id,
      company_name: props.dialog.state.company.company_name, //協力会社名
      worker: [], //未登録ユーザー
      assignedWorker: [], //登録済みユーザー,
      checkedWorker: [],
      checkedAssignWorker: [],
      field_tree_id: props.dialog.state.field_tree_id,
      field_id: sessionStorage.getItem('field_id'),
      //field_id      : props.dialog.state.field_id,
      validate: true,
      visibleDialogFlag: false,
      visibleStatusDialog: false,
      errorMessage: '',
      isManagerPermission: props.dialog.state.isManagerPermission,
      partnerCompanyBranchId: '',
      localPartnerCompanyBranchId: '',
      searchName: '',
      addPartnerBoxDetailPermission:
        props.dialog.state.addPartnerBoxDetailPermission,
      isMoveInProgress: false,
    };
  }
  async componentDidMount() {
    await this.loadWorker();
  }

  // eslint-disable-next-line no-unused-vars
  doBeforeMoveItemsToRight = async items => {
    return true;
  };
  /**
   * 右へ移動
   */

  moveToRight = callback => {
    //移動するデータ
    let move = _.filter(this.state.worker, worker => {
      return worker.checked == true;
    });
    let _worker = _.cloneDeep(this.state.worker);

    _.each(move, worker => {
      worker.checked = false;
    });
    // console.log('移動するデータ', move);

    this.doBeforeMoveItemsToRight(move).then(result => {
      if (!result) {
        // 失敗したらチェック状態をもとに戻す
        _.each(move, worker => {
          worker.checked = true;
        });
        return;
      }
      //左から削除
      _.remove(_worker, worker => {
        return worker.checked == true;
      });
      this.setState({ worker: _worker });

      //右に追加
      let _assignedWorker = _.cloneDeep(this.state.assignedWorker);
      this.setState({
        assignedWorker: _.concat(
          _assignedWorker,
          _.map(move, worker => {
            worker.checked = false;
            return worker;
          })
        ),
      }, () => {
        if (typeof callback === 'function') {
          callback();
        }
      });
    });
  };

  // eslint-disable-next-line no-unused-vars
  doBeforeMoveItemsToLeft = async items => {
    return true;
  };
  /**
   * 左へ移動
   */
  moveToLeft = () => {
    //移動するデータ
    let move = _.filter(this.state.assignedWorker, worker => {
      return worker.checked == true;
    });
    let _assignedWorker = _.cloneDeep(this.state.assignedWorker);

    _.each(move, worker => {
      worker.checked = false;
    });
    // console.log('移動するデータ', move);

    this.doBeforeMoveItemsToLeft(move).then(result => {
      if (!result) {
        // 失敗したらチェック状態をもとに戻す
        _.each(move, worker => {
          worker.checked = true;
        });
        return;
      }
      // 右側のリスト（現場に登録中作業員）を設定する
      // 既存の右側のリストにて、移動（右→左）リストを除外する
      _.remove(_assignedWorker, worker => {
        const target = move.find(cmp => cmp.id === worker.id);
        if (target) {
          return true;
        }
      });
      this.setState({ assignedWorker: _assignedWorker });

      // 退職作業員は左に追加するリストから除外
      move = _.filter(move, worker => {
        return WORKER_STATUS.RETIREMENT.ID !== worker.worker_status;
      });

      //左に追加
      //左側には移動（右→左）リストを追加する
      let _worker = _.cloneDeep(this.state.worker);
      this.setState({
        worker: _.concat(
          _worker,
          _.map(move, worker => {
            worker.checked = false;
            worker.jobs = [];
            delete worker.jobs;
            return worker;
          })
        ),
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/FieldTreeWorkerManagerBase.jsx